<template>
  <v-container fluid pt-10>
    <v-layout wrap row pa-2>
      <v-flex sm12 md12 lg12>
        <v-card style="height: 100%; border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
          <v-flex sm12 md12 lg12 pa-4>
            <v-layout row wrap align-center>
              <v-flex pl-2 @click="seeTable = !seeTable">
                <h2>{{ tituloLote }}</h2>
              </v-flex>
              <v-spacer />
              <div class="d-flex flex-row align-center">
                <v-flex
                  class="pr-4"
                >
                </v-flex>
                <v-flex
                  class="pr-4"
                >
                   <v-btn
                    @click="onGenerateFalClick"
                    color="orange darken-4"
                    class="white--text"
                  >
                    Gerar FAL
                  </v-btn>
                </v-flex>
                <v-tooltip bottom v-if="cdEmpresa !== 4">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      id="boletimSanitario"
                      fab
                      small
                      dark
                      :color="podeGerarBoletimSanitario ? 'red' : 'grey'"
                      @click="toBoletimSanitario"
                      style="margin:2px;"
                      v-on="on"
                    >
                      <v-icon dark small>fas fa-file-medical</v-icon>
                    </v-btn>
                  </template>
                  <span>Boletim Sanitário</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      id="editar"
                      fab
                      small
                      dark
                      color="success"
                      v-on="on"
                      @click.prevent.stop="editRegistro"
                      style="margin:2px;"
                    >
                      <v-icon dark small>fas fa-edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Registro</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      id="searchRegistro"
                      fab
                      small
                      dark
                      color="info"
                      v-on="on"
                      @click="goSearch"
                      style="margin:2px;"
                    >
                      <v-icon dark small>fas fa-search</v-icon>
                    </v-btn>
                  </template>
                  <span>Pesquisar novo Lote</span>
                </v-tooltip>
                <v-btn id="seeTable" fab text small @click="seeTable = !seeTable">
                  <v-icon dark small v-if="seeTable">fas fa-angle-up</v-icon>
                  <v-icon dark small v-else>fas fa-angle-down</v-icon>
                </v-btn>
              </div>
            </v-layout>
          </v-flex>
          <v-flex sm11 xs11 md12 lg12 v-if="seeTable" pa-2>
            <v-data-table
              :headers="headersLote" hide-default-footer
              no-results-text="Nenhum registro encontrado" :items="valuesLote" color="secondary"
              loading-text="Carregando registros...aguarde"
            >
            </v-data-table>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-layout row wrap justify-center class="full-height" v-if="exibeDadosAmbiencia">
      <v-flex pa-2>
        <v-card>
          <v-toolbar flat>
            <span>Ambiência</span>
            <v-tooltip bottom style="margin-left: 10px;">
              <template v-slot:activator="{ on }">
                <v-btn
                  id="goAmbienciaTemperatura"
                  fab
                  small
                  dark
                  color="#FF5252"
                  style="margin: 2px; margin-left: 5px;"
                  v-on="on"
                  @click="goToAmbiencia('temperature')"
                >
                  <v-icon medium>fas fa-thermometer-half</v-icon>
                </v-btn>
              </template>
              <span>Temperatura</span>
            </v-tooltip>
            <v-tooltip bottom style="margin-left: 10px;">
              <template v-slot:activator="{ on }">
                <v-btn
                  id="goAmbienciaCo2"
                  fab
                  small
                  dark
                  color="success"
                  style="margin: 2px;"
                  v-on="on"
                  @click="goToAmbiencia('co2')"
                >
                  <v-img :src="icon" :aspect-ratio="1/1" />
                </v-btn>
              </template>
              <span>CO2</span>
            </v-tooltip>
            <v-tooltip bottom style="margin-left: 10px;">
              <template v-slot:activator="{ on }">
                <v-btn
                  id="goAmbienciaUmidade"
                  fab
                  small
                  dark
                  color="info"
                  style="margin: 2px;"
                  v-on="on"
                  @click="goToAmbiencia('humidity')"
                >
                  <v-icon small>fas fa-tint</v-icon>
                </v-btn>
              </template>
              <span>Umidade</span>
            </v-tooltip>
            <v-tooltip bottom style="margin-left: 10px;">
              <template v-slot:activator="{ on }">
                <v-btn
                  id="goItu"
                  fab
                  small
                  dark
                  color="cyan"
                  style="margin: 2px;"
                  v-on="on"
                  @click="goToAmbiencia('itu')"
                >
                  <v-icon small>fas fa-thermometer</v-icon>
                </v-btn>
              </template>
              <span>ITU</span>
            </v-tooltip>
             <v-tooltip bottom style="margin-left: 10px;">
              <template v-slot:activator="{ on }">
                <v-btn
                  id="goWaterConsume"
                  fab
                  small
                  dark
                  color="purple"
                  style="margin: 2px;"
                  v-on="on"
                  @click="goToAmbiencia('water-consume')"
                >
                  <v-icon small>fas fa-hand-holding-water</v-icon>
                </v-btn>
              </template>
              <span>Consumo de água</span>
            </v-tooltip>
            <v-tooltip bottom style="margin-left: 10px;">
              <template v-slot:activator="{ on }">
                <v-btn
                  id="goWaterTemp"
                  fab
                  small
                  dark
                  color="warning"
                  style="margin: 2px;"
                  v-on="on"
                  @click="goToAmbiencia('water-temperature')"
                >
                  <v-icon small>mdi-cup-water</v-icon>
                </v-btn>
              </template>
              <span>Temperatura da água</span>
            </v-tooltip>
            <v-tooltip bottom style="margin-left: 10px;">
              <template v-slot:activator="{ on }">
                <v-btn
                  id="goAmbienciaTodos"
                  fab
                  small
                  dark
                  color="#10303D"
                  style="margin: 2px;"
                  v-on="on"
                  @click="goToAmbiencia('all')"
                >
                  <v-icon small>fas fa-heartbeat</v-icon>
                </v-btn>
              </template>
              <span>Todos</span>
            </v-tooltip>
          </v-toolbar>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 md6 lg2 pa-2>
        <LoteCardWithHover :value="alojamentoCardValue" :large="true" title="Alojamento" />
      </v-flex>
      
      <v-flex xs12 sm6 md6 lg2 pa-2>
        <LoteCardWithHover :value="racaoCardValue" title="Ração" />
      </v-flex>
      
      <v-flex xs12 sm6 md6 lg2 pa-2>
        <LoteCardWithHover
          :marcador="loteProducao.marcadorMortalidade"
          :mortalidade="true"
          :value="mortalidadeCardValue"
          title="Mortalidade"
        />
      </v-flex>
      
      <v-flex xs12 sm6 md6 lg2 pa-2>
        <LoteCardWithHover
          :large="true"
          :value="saldoCardValue"
          title="Saldo de Animais"
        />
        <!-- <v-card>
          <v-toolbar flat>
            <span>Saldo de Animais</span>
          </v-toolbar>
          <v-list>
            <v-layout justify-center row class="display-1">
              <v-flex text-xs-center justify-center lg12 mb-5 style="display: -webkit-box;">
                                <span>
                                    {{ loteProducao.qtSaldoAnimais }}
                                </span>
              </v-flex>
            </v-layout>
          </v-list>
        </v-card> -->
      </v-flex>
      
      <v-flex xs12 sm6 md6 lg2 pa-2>
        <LoteCardWithHover :value="pesoCardValue" :title="tituloPesoCard" />
      </v-flex>
      
      <v-flex xs12 sm6 md6 lg2 pa-2>
        <v-card>
          <v-toolbar flat>
            <span>{{ tituloGPD }}</span>
          </v-toolbar>
          <v-list>
            <v-layout justify-center row class="display-1">
              <v-flex text-xs-center justify-center lg12 mb-5 style="display: -webkit-box;">
                <span> {{ qtGpdEstimado }} kg </span>
              </v-flex>
            </v-layout>
          </v-list>
        </v-card>
      </v-flex>
    
    </v-layout>
    
    <v-layout row wrap justify-center v-if="loteProducao.qtBaixas > 0">
      <v-flex sm6 md6 lg8 pa-2>
        <v-card style="height: 100%;">
          <v-toolbar flat>
            <span v-if="exibeGraficoMotivoMortalidade">Mortalidade por Semana</span>
            <span v-else>Mortalidade vs Ração</span>
            <v-spacer />
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  id="changeGraifcoMortalidade"
                  fab
                  small
                  dark
                  color="info"
                  v-on="on"
                  @click="exibeGraficoMotivoMortalidade = !exibeGraficoMotivoMortalidade"
                >
                  <v-icon v-if="exibeGraficoMotivoMortalidade" small>fa-table</v-icon>
                  <v-icon v-else small>fa-chart-area</v-icon>
                </v-btn>
              </template>
              <span v-if="exibeGraficoMotivoMortalidade">Visualizar tabela</span>
              <span v-else>Visualizar gráfico</span>
            </v-tooltip>
          </v-toolbar>
          <v-layout row wrap>
            <v-flex pa-2 v-if="exibeGraficoMotivoMortalidade">
              <LoteProducaoLimiteMortalidadeGrafico :values="mortalityGoalGraphValues" />
            </v-flex>
            <v-flex pa-2 v-else>
              <LoteProducaoMortalidadesTabela :values="listaMortalityRation" />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      
      <v-flex sm6 md6 lg4 pa-2>
        <v-card style="height: 100%;">
          <v-toolbar flat>
            <span>Motivos de Mortalidade</span>
            <v-spacer />
            <v-btn
              v-if='$vuetify.breakpoint.name != "xs"'
              id="changeGraficoCausasMortalidade"
              fab
              small
              color="info"
              @click="exibeGraficoMortalidadeCauses = !exibeGraficoMortalidadeCauses"
            >
              <v-icon v-if="exibeGraficoMortalidadeCauses" small>fa-table</v-icon>
              <v-icon v-else small>fa-chart-area</v-icon>
            </v-btn>
          </v-toolbar>
          <v-layout row wrap>
            <v-flex pa-2 v-if="exibeGraficoMortalidadeCauses">
              <LoteProducaoCausasMortalidadeGrafico :values="mortalityReasonsGraphValues" />
            </v-flex>
            <v-flex pa-2 v-else>
              <LoteProducaoCausasMortalidadeTabela :values="mortalityReasonsGraphValues" />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-layout row wrap justify-center class="full-height">
      <v-flex pa-2>
        <v-card>
          <v-toolbar flat v-if="Math.abs(loteProducao.nrDesvioConsumo) < qtDesvioMedioConsumo">
            <span>Consumo de ração</span>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-1"
              id="changeTabelaConsumo"
              fab
              small
              color="info"
              @click="exibeGraficosConsumoRacao = !exibeGraficosConsumoRacao"
            >
              <v-icon v-if="exibeGraficosConsumoRacao" small>fa-table</v-icon>
              <v-icon v-else small>fa-chart-area</v-icon>
            </v-btn>
            <DialogCadastroSaldoRacao
              @saved="selectRationBalanceSelected" :dialog="dialogRationBalance" @closeDialog="closeDialogRationBalance"
              :rec="atualRationBalance" @openDialog="openDialogRationBalance"
            />
          </v-toolbar>
          
          <v-toolbar flat class="blink_me" v-else-if="Math.abs(loteProducao.nrDesvioConsumo) >= qtDesvioMaximoConsumo">
            <span>Consumo de ração</span>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-1"
              id="changeGraficoConsumo"
              fab
              small
              color="info"
              @click="exibeGraficosConsumoRacao = !exibeGraficosConsumoRacao"
            >
              <v-icon v-if="exibeGraficosConsumoRacao" small>fa-table</v-icon>
              <v-icon v-else small>fa-chart-area</v-icon>
            </v-btn>
            <DialogCadastroSaldoRacao
              @saved="selectRationBalanceSelected" :dialog="dialogRationBalance" @closeDialog="closeDialogRationBalance"
              :rec="atualRationBalance" @openDialog="openDialogRationBalance"
            />
          </v-toolbar>
          
          <v-toolbar
            flat
            v-else
            style="background: linear-gradient(to right, rgba(255, 84, 41, 0.4) 0%, rgba(16, 48, 61, 0) 10%);"
          >
            <span>Consumo de ração</span>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-1"
              id="changeGraficoConsumoRacao"
              fab
              small
              color="info"
              @click="exibeGraficosConsumoRacao = !exibeGraficosConsumoRacao"
            >
              <v-icon v-if="exibeGraficosConsumoRacao" small>fa-table</v-icon>
              <v-icon v-else small>fa-chart-area</v-icon>
            </v-btn>
            <DialogCadastroSaldoRacao
              @saved="selectRationBalanceSelected" :dialog="dialogRationBalance" @closeDialog="closeDialogRationBalance"
              :rec="atualRationBalance" @openDialog="openDialogRationBalance"
            />
          </v-toolbar>
          
          <v-layout row wrap pa-2 v-if="exibeGraficosConsumoRacao">
            <v-flex xs12 md6>
              <p class="text-center">Consumo Acumulado</p>
              <LoteProducaoConsumoRacaoGrafico :values="listaConsumoRealAcumulado" />
            </v-flex>
            <v-flex xs12 md6>
              <p class="text-center">Consumo Diário</p>
              <LoteProducaoConsumoRacaoGrafico :values="listaConsumoRealWeekly" :weekly="true" />
            </v-flex>
          </v-layout>
          
          
          <v-layout row pa-4 v-else>
            <v-flex md12 lg12 xs12 sm12>
              <LoteProducaoConsumoRacaoTabela
                :height="250" :values="loteProducao.jsonConsumoReal" :isLoading="isLoadingConsumoReal" @reload="reload"
                @editRationBalance="editRationBalance"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-layout row wrap v-if="exibePesoDetalhe">
      <v-flex pa-2>
        <v-card>
          <v-toolbar flat>
            <span>Peso</span>
            <v-spacer></v-spacer>
            <DialogInformarPesoFinal
              @saved="selectPesoFinalSelected" :dialog="dialogInformarPesoFinal" @closeDialog="closeDialogInformarPesoFinal"
              :peso="loteProducao.nrPesoFinal" @openDialog="openDialogInformarPesoFinal"
            />
          </v-toolbar>
          <v-layout row wrap pa-2>
            <v-flex xs12 md6>
              <LoteProducaoConsumoRacaoGrafico :values="listaPesoGrafico" eixoYText="Peso" />
            </v-flex>
            <v-flex xs12 md6>
              <TabelaPesoDetalhe
                :values="loteProducao.jsonPeso"
                :diasLote="loteProducao.nrDiasAlojado"
                :exibeText="exibeTextPesoProjetado"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-layout row wrap justify-center>
      <v-flex pa-2>
        <v-card>
          <v-row wrap class="fill-height">
            <v-col>
              <v-layout row wrap ma-2 v-if="!$vuetify.breakpoint.xs">
                <v-flex xs12 sm12 md12 lg12>
                  <span style="margin-top: 10px;">Exibir informações de:</span>
                </v-flex>
                <v-flex xs12 sm6 md4 lg2>
                  <v-switch
                    @change="loadDadosCalendario"
                    v-model="flEntrdadaAnimais"
                    color="info"
                    class="ma-2"
                    label="Alojamentos"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md4 lg2>
                  <v-switch
                    @change="loadDadosCalendario"
                    v-model="flEntradaRacao"
                    color="info"
                    class="ma-2"
                    label="Entradas de Ração"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md4 lg2>
                  <v-switch
                    @change="loadDadosCalendario"
                    v-model="flBaixas"
                    color="info"
                    class="ma-2"
                    label="Mortalidades"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md4 lg2>
                  <v-switch
                    @change="loadDadosCalendario"
                    v-model="flAdmMedicamento"
                    color="info"
                    class="ma-2"
                    label="Medicamentos"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md4 lg2>
                  <v-switch
                    @change="loadDadosCalendario"
                    v-model="flSaidaAnimais"
                    color="info"
                    class="ma-2"
                    label="Saídas de Animais"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md4 lg2 v-if="exibeDadosAmbiencia">
                  <v-switch
                    @change="loadDadosCalendario"
                    v-model="flAmbiencia"
                    color="info"
                    class="ma-2"
                    label="Ambiência"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap ma-2>
                <v-flex xs4 sm2 md1 lg1>
                  <v-menu :close-on-content-click="true" offset-x>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-1" id="addRegistro" fab small @click="visualizarTodasInfos" dark color="info">
                        <v-icon dark small>fas fa-clipboard-list</v-icon>
                      </v-btn>
                      <v-btn class="ma-1" id="addRegistro" fab small v-on="on" dark color="#10303D">
                        <v-icon dark small>fas fa-plus</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item id="goEntradaAnimais" @click="novoRegistroDetalhesLote('loteEntradaAnimais')">
                        <v-list-item-content>
                          <v-list-item-title>Alojamento</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item id="goEntradaRacao" @click="novoRegistroDetalhesLote('loteEntradaRacao')">
                        <v-list-item-content>
                          <v-list-item-title>Entrada de Ração</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item id="goBaixa" @click="novoRegistroDetalhesLote('loteBaixa')">
                        <v-list-item-content>
                          <v-list-item-title>Mortalidade</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item id="goAdmFarmaco" @click="novoRegistroDetalhesLote('loteAdmFarmacos')">
                        <v-list-item-content>
                          <v-list-item-title>Medicamentos</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item id="goSaidaAnimais" @click="novoRegistroDetalhesLote('loteSaidaAnimais')">
                        <v-list-item-content>
                          <v-list-item-title>Saída de Animais</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-flex>
                <v-flex xs4 sm2 md1 lg1>
                  <v-btn outlined class="mr-4" @click="setToday">
                    Hoje
                  </v-btn>
                </v-flex>
                <v-flex xs4 sm2 md1 lg1>
                  <v-btn fab text small @click="prev">
                    <v-icon small>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn fab text small @click="next">
                    <v-icon small>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md8 lg8>
                  <v-toolbar-title>{{ titleCalendar }}</v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm12 md1 lg1>
                  <v-menu bottom right>
                    <template v-slot:activator="{ on }">
                      <v-btn outlined v-on="on">
                        <span>{{ typeToLabel[type].name }}</span>
                        <v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="type = 'day'">
                        <v-list-item-title>Dia</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'week'">
                        <v-list-item-title>Semana</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'month'">
                        <v-list-item-title>Mês</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 dias</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-sheet height="700">
                <v-calendar
                  ref="calendar"
                  v-model="focus"
                  color="primary"
                  :short-months="false"
                  :short-weekdays="false"
                  :events="valoresCalendario"
                  :event-color="getEventColor"
                  :event-margin-bottom="2"
                  locale="pt-br"
                  :now="today"
                  :type="type"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
                  @change="updateRange"
                >
                </v-calendar>
                <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
                  <v-card color="grey lighten-4" min-width="350px" flat>
                    <v-toolbar :color="selectedEvent.color" dark>
                      <v-toolbar-title>
                        <h4>{{ selectedEvent.name }}</h4>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn v-if="selectedEvent.tipo != 'EV'" icon @click="editarRegistroCalendario(selectedEvent)">
                        <v-icon small>fas fa-pen</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text style="background-color: white;">
                      <span v-html="selectedEvent.details"></span>
                    </v-card-text>
                    
                    <v-card-actions style="background-color:white;">
                      <v-btn id="cancel" rounded @click="selectedOpen = false" style="background-color:#e8e8e8;">
                        <span style="padding-right: 5px;"> Cancelar </span>
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
  
  </v-container>
</template>

<script>

import {dateIsoToLocal, dateLocalToIso, dateTimeIsoToLocal, daysBetweenDates, uepTypeExpand} from '@/filters/utils'
import LoteCardWithHover from "@/components/loteProducao/LoteCardWithHover.vue"
import LoteProducaoLimiteMortalidadeGrafico from "@/components/loteProducao/LoteProducaoLimiteMortalidadeGrafico.vue"
import LoteProducaoMortalidadesTabela from "@/components/loteProducao/LoteProducaoMortalidadesTabela.vue"
import LoteProducaoCausasMortalidadeGrafico from "@/components/loteProducao/LoteProducaoCausasMortalidadeGrafico.vue"
import LoteProducaoCausasMortalidadeTabela from "@/components/loteProducao/LoteProducaoCausasMortalidadeTabela.vue"
import DialogCadastroSaldoRacao from "@/components/dialogs/DialogCadastroSaldoRacao.vue"
import DialogInformarPesoFinal from "@/components/dialogs/DialogInformarPesoFinal.vue"
import LoteProducaoConsumoRacaoGrafico from "@/components/loteProducao/LoteProducaoConsumoRacaoGrafico.vue"
import LoteProducaoConsumoRacaoTabela from "@/components/loteProducao/LoteProducaoConsumoRacaoTabela.vue"
import TabelaPesoDetalhe from "@/components/loteProducao/TabelaPesoDetalhe.vue"
import LoteProducaoTemperaturaGrafico from "@/components/loteProducao/LoteProducaoTemperaturaGrafico.vue"
import LoteProducaoCO2Grafico from "@/components/loteProducao/LoteProducaoCO2Grafico.vue"
import LoteProducaoUmidadeGrafico from "@/components/loteProducao/LoteProducaoUmidadeGrafico.vue"
import LoteProducaoCortinaGrafico from "@/components/loteProducao/LoteProducaoCortinaGrafico.vue"

import iconImage from "@/assets/periodic-table-co2.png"
import moment from "moment"
import {keysToCamel} from "@/common/utils"
import {includes} from "lodash/collection"
import { mapState } from 'vuex';

const AMBIENCE_URL = process.env.VUE_APP_URL_API_AMBIENCIA
const ALERT_TEMP_LOWER_MAP_LIST = [
  "temp_lower_week_0",
  "temp_lower_week_1",
  "temp_lower_week_2",
  "temp_lower_week_3",
  "temp_lower_week_4",
  "temp_lower_week_5",
  "temp_lower_week_6",
]
const ALERT_TEMP_HIGHER_MAP_LIST = [
  "temp_higher_week_0",
  "temp_higher_week_1",
  "temp_higher_week_2",
  "temp_higher_week_3",
  "temp_higher_week_4",
  "temp_higher_week_5",
  "temp_higher_week_6",
]
const ALERT_CO2_1500_PPM_MAP_LIST = [
  "co2_1500_ppm"
]
const ALERT_CO2_3000_PPM_MAP_LIST = [
  "co2_3000_ppm"
]
const ALERT_WATER_TEMP_HIGHER_MAP_LIST = [
  "water_temperature_higher"
]
const ALERT_ITU_LOWER_MAP_LIST = [
  "itu_lower"
]
const ALERT_ITU_HIGHER_MAP_LIST = [
  "itu_higher"
]

export default {
  name: 'LoteProducao',
  components: {
    LoteCardWithHover,
    LoteProducaoLimiteMortalidadeGrafico,
    LoteProducaoMortalidadesTabela,
    LoteProducaoCausasMortalidadeGrafico,
    LoteProducaoCausasMortalidadeTabela,
    DialogCadastroSaldoRacao,
    LoteProducaoConsumoRacaoGrafico,
    LoteProducaoConsumoRacaoTabela,
    TabelaPesoDetalhe,
    LoteProducaoTemperaturaGrafico,
    LoteProducaoCO2Grafico,
    LoteProducaoUmidadeGrafico,
    LoteProducaoCortinaGrafico,
    DialogInformarPesoFinal,
  },
  data() {
    return {
      loteProducao: {},
      medicines: [],
      deaths: [],
      ration: [],
      outputs: [],
      inputs: [],
      estabelecimento: {},
      uep: {},
      maxMortesPercent: null,
      produtor: {},
      displayName: '',
      headersLote: [
        {text: "Identificador", value: "idLoteProducao", sortable: false},
        {text: "Código Oficial", value: "nrCodigoOficial", sortable: false},
        {text: "Lote de Controle", value: "nrControle", sortable: false},
        {text: "Estabelecimento", value: "dsEstabelecimento", sortable: false},
        {text: "Número Unidade Exploração", value: "dsUEP", sortable: false},
        {text: "Abertura", value: "dtCriacaoLote", sortable: false},
        {text: "Extensionista", value: "nmExtensionista", sortable: false},
        {text: "Gênero dos animais", value: "dsTipoSexo", sortable: false},
        {text: "Tabela de Consumo", value: "nmTabela", sortable: false}
      ],
      dtDifereceDateFimRacao: "",
      dtFimRacao: "",
      totalRation: 0,
      tabelaMetaMortalidade: [],
      metaMortalidadeSemana: {},
      qtPesoReal: 0,
      qtPesoEstimado: 0,
      nrSemanaTabela: 0,
      qtGpdReal: 0,
      isLoadingConsumoReal: false,
      listaConsumoReal: [],
      listaConsumoRealAcumulado: [],
      listaConsumoRealWeekly: [],
      listaPesoGrafico: [],
      listaPesoDetalhe: [],
      exibeGraficoMotivoMortalidade: false,
      mortalityGoalGraphValues: {},
      listaMortalityRation: [],
      exibeGraficoMortalidadeCauses: true,
      mortalityReasonsGraphValues: [],
      exibeGraficosConsumoRacao: false,
      dialogRationBalance: false,
      dialogInformarPesoFinal: false,
      atualRationBalance: {},
      exibePesoDetalhe: false,
      today: this.dateLocalToIso(new Date().toLocaleDateString('pt-br')),
      focus: this.dateLocalToIso(new Date().toLocaleDateString('pt-br')),
      type: 'week',
      typeToLabel: {
        month: {
          type: 'Month',
          name: 'Mês',
        },
        week: {
          type: 'Week',
          name: 'Semana',
        },
        day: {
          type: 'Day',
          name: 'Dia',
        },
        '4day': {
          type: '4 Days',
          name: '4 dias'
        }
      },
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      valoresCalendario: [],
      flEntradaRacao: true,
      flBaixas: true,
      flAdmMedicamento: true,
      flEntrdadaAnimais: true,
      flSaidaAnimais: true,
      flAmbiencia: true,
      seeTable: false,
      seeAmbiencia: true,
      offset: true,
      exibeTextPesoProjetado: false,
      idUltimoBoletim: null,
      pesquisaNovoBoletim: false,
    }
  },
  computed: {
    ...mapState(["listaGeneros"]),
    cdEmpresa() {
      return this.$keycloak['tokenParsed']["PARTNERID"]
    },
    icon() {
      return iconImage
    },
    exibeDadosAmbiencia() {
      if (this.loteProducao == undefined || this.loteProducao.jsonEstabelecimento == undefined ||
        this.loteProducao.jsonEstabelecimento.nrCodigoOficial == undefined || this.loteProducao.jsonUnidadeExploracao == undefined ||
        this.loteProducao.jsonUnidadeExploracao.nrUnidadeExploracao == undefined) {
        return false
      }
      if (this.loteProducao.jsonUnidadeExploracao.stPossuiAmbiencia != undefined && this.loteProducao.jsonUnidadeExploracao.stPossuiAmbiencia) {
        return true
      }
      return false
    },
    tituloLote() {
      if (!this.loteProducao.blLoteFechado) {
        return this.displayName
      } else {
        return this.displayName + ' - FECHADO DIA ' + this.loteProducao.dtFechamentoLote
      }
    },
    tiposGenero() {
      return this.$store.state.tiposGenero
    },
    tabelasMetaMortalidade() {
      return this.$store.state.tabelasMetaMortalidade
    },
    tabelaCrescimentoAnimal() {
      return this.$store.state.tabelaCrescimentoAnimal[this.$store.state.token.PARTNERID]
    },
    valuesLote() {
      var context = this
      var lote = [{
        idLoteProducao: context.loteProducao.idLoteProducao,
        nrCodigoOficial: context.loteProducao.jsonEstabelecimento != undefined ? context.loteProducao.jsonEstabelecimento.nrCodigoOficial : "",
        nrControle: context.loteProducao.nrLoteControle,
        dsEstabelecimento: context.loteProducao.jsonEstabelecimento != undefined ? context.loteProducao.jsonEstabelecimento.nmEstabelecimento : "",
        dsUEP: context.loteProducao.jsonUnidadeExploracao != undefined ?
          context.loteProducao.jsonUnidadeExploracao.nrUnidadeExploracao + " - " + context.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao : "",
        dtCriacaoLote: context.loteProducao.dtCriacaoLote,
        nmExtensionista: context.loteProducao.nmExtensionista,
        dsTipoSexo: context.loteProducao.dsTipoSexo,
        nmTabela: context.loteProducao.nmTabela
      }]
      return lote
    },
    alojamentoCardValue() {
      var encerramento = ""
      if (this.loteProducao.jsonUnidadeExploracao != undefined) {
        var qtDias = 0
        if (!this.loteProducao.blLoteFechado) {
          if (this.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao == "Terminação") {
            qtDias = this.$store.getters.getValorTabela("qtDiasAlojamentoTerminacao")[0] != undefined ?
              this.$store.getters.getValorTabela("qtDiasAlojamentoTerminacao")[0].stValor : 0
          } else if (this.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao == "Creche") {
            qtDias = this.$store.getters.getValorTabela("qtDiasAlojamentoCreche")[0] != undefined ?
              this.$store.getters.getValorTabela("qtDiasAlojamentoCreche")[0].stValor : 0
          } else //(this.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao == "Wean to Finish")
          {
            qtDias = this.$store.getters.getValorTabela("qtDiasAlojamentoWeanToFinish")[0] != undefined ?
              this.$store.getters.getValorTabela("qtDiasAlojamentoWeanToFinish")[0].stValor : 0
          }
          // else {
          //   qtDias = this.$store.getters.getValorTabela("qtDiasAlojamentoUpl")[0] != undefined ?
          //     this.$store.getters.getValorTabela("qtDiasAlojamentoUpl")[0].stValor : 0
          // }
          if (this.loteProducao.dtAlojamento != null) {
            var data = new Date(this.dateLocalToIso(this.loteProducao.dtAlojamento))
            data.setDate(data.getDate() + parseInt(qtDias) + 1)
            encerramento = data.toLocaleDateString("pt-br")
          }
        } else {
          encerramento = this.loteProducao.dtFechamentoLote
          qtDias = '--'
        }
      }
      
      var totalDiasAlojado = this.loteProducao.nrDiasAlojado ? this.loteProducao.nrDiasAlojado < 0 ? '--' : this.loteProducao.nrDiasAlojado : '--'
      totalDiasAlojado = totalDiasAlojado != '--' ? totalDiasAlojado > 1 ? totalDiasAlojado + " Dias" : totalDiasAlojado + " Dia" : totalDiasAlojado
      
      var rec = {
        cardInfo: totalDiasAlojado,
        hoverList: [
          {
            text: "Data de alojamento:",
            value: this.loteProducao.dtAlojamento
          },
          {
            text: !this.loteProducao.blLoteFechado ? "Encerramento estimado:" : "Encerramento:",
            value: encerramento
          },
          {
            text: "Quantidade total:",
            value: this.loteProducao.qtAlojados
          },
          {
            text: "Machos:",
            value: this.loteProducao.qtMachosAlojados != null ? this.loteProducao.qtMachosAlojados : '-'
          },
          {
            text: "Fêmeas:",
            value: this.loteProducao.qtFemeasAlojados != null ? this.loteProducao.qtFemeasAlojados : '-'
          },
          {
            text: "Peso médio:",
            value: this.loteProducao.nrPesoMedio != null ? this.loteProducao.nrPesoMedio + " kg" : " -- "
          }
        ]
      }
      return rec
    },
    racaoCardValue() {
      var rec = {
        cardInfo: this.dtDifereceDateFimRacao == 1 ? this.dtDifereceDateFimRacao + ' Dia' : this.dtDifereceDateFimRacao + ' Dias',
        hoverList: [
          {
            text: "Término da ração:",
            value: this.dtFimRacao
          },
          {
            text: "Total de ração:",
            value: this.totalRation.toLocaleString('pt-br') + ' kg'
          }
        ]
      }
      return rec
    },
    mortalidadeCardValue() {
      var meta = this.metaMortalidadeSemana.mortalidade != undefined ? this.metaMortalidadeSemana.mortalidade.toFixed(1) : '--'
      var indice = this.maxMortesPercent != null ? this.maxMortesPercent.toFixed(2) : '--'
      var rec = {
        cardInfo: this.loteProducao.nrIndiceBaixas != undefined ? indice + " / " + meta + " %" : "0%",
        hoverList: [
          {
            text: "Quantidade total:",
            value: this.loteProducao.qtBaixas
          },
          {
            text: "Machos:",
            value: this.loteProducao.qtMachosBaixas != undefined && this.loteProducao.qtMachosBaixas != null ? this.loteProducao.qtMachosBaixas : '-'
          },
          {
            text: "Fêmeas:",
            value: this.loteProducao.qtFemeasBaixas != undefined && this.loteProducao.qtFemeasBaixas != null ? this.loteProducao.qtFemeasBaixas : '-'
          }
        ]
      }
      return rec
    },
    saldoCardValue() {
      var rec = {
        cardInfo: this.loteProducao.qtSaldoAnimais != undefined ? this.loteProducao.qtSaldoAnimais : '0',
        hoverList: [
          {
            text: "Machos:",
            value: this.loteProducao.qtSaldoMachos != null ? this.loteProducao.qtSaldoMachos : '-'
          },
          {
            text: "Fêmeas:",
            value: this.loteProducao.qtSaldoFemeas != null ? this.loteProducao.qtSaldoFemeas : '-'
          }
        ]
      }
      return rec
    },
    tituloPesoCard() {
      if (this.loteProducao.nrPesoFinal != undefined && this.loteProducao.nrPesoFinal > 0) {
        return "Peso final"
      }
      else if (this.loteProducao.jsonUnidadeExploracao != undefined && this.loteProducao.jsonUnidadeExploracao.csTipoUEP == "TR") {
        return this.$keycloak.tokenParsed.PARTNERID == 4 || this.$keycloak.tokenParsed.PARTNERID == 999 ? "Peso projetado" : "Peso estimado semana"
      } else {
        return "Peso estimado semana"
      }
    },
    pesoCardValue() {
      var rec = {}
      if (this.loteProducao.nrPesoFinal != undefined && this.loteProducao.nrPesoFinal > 0) {
        rec = {
          cardInfo: this.loteProducao.nrPesoFinal.toFixed(2) + " kg",
          hoverList: [
            {
              text: "Peso estimado",
              value: this.loteProducao.nrPesoEstimado.toFixed(2) + " kg"
            },
            {
              text: "Semana de vida",
              value: this.nrSemanaTabela
            }
          ]
        }
      }
      else if (this.$keycloak.tokenParsed.PARTNERID != 4 && this.$keycloak.tokenParsed.PARTNERID != 999) {
        rec = {
          cardInfo: this.loteProducao.nrPesoEstimado != undefined ? this.loteProducao.nrPesoEstimado.toFixed(2) + " kg" : "--",
          hoverList: [
            {
              text: "Semana de vida",
              value: this.nrSemanaTabela
            },
            {
              text: "Peso estimado conforme tabela crescimento",
              value: "",
              link: "/tabelaCrescimentoAnimal"
            }
          ]
        }
      } else {
        rec = {
          cardInfo: this.loteProducao.nrPesoEstimado != undefined ? this.loteProducao.nrPesoEstimado.toFixed(2) + " kg" : "--",
          hoverList: [
            {
              text: "Semana de vida",
              value: this.nrSemanaTabela
            }
          ]
        }
      }
      return rec
    },
    tituloGPD() {
      if (this.loteProducao.jsonUnidadeExploracao != undefined && this.loteProducao.jsonUnidadeExploracao.csTipoUEP == "TR") {
        return this.$keycloak.tokenParsed.PARTNERID == 4 ? "GPD projetado" : "GPD estimado"
      } else {
        return "GPD estimado"
      }
    },
    qtGpdEstimado() {
      return this.loteProducao.nrGpdEstimado != undefined ? this.loteProducao.nrGpdEstimado.toFixed(3) : 0
    },
    qtDesvioMaximoConsumo() {
      return this.$store.getters.getValorTabela("qtDesvioMaximoConsumoPercentual")[0] != undefined ?
        this.$store.getters.getValorTabela("qtDesvioMaximoConsumoPercentual")[0].stValor : 5
    },
    qtDesvioMedioConsumo() {
      return this.$store.getters.getValorTabela("qtDesvioMedioConsumoPercentual")[0] != undefined ?
        this.$store.getters.getValorTabela("qtDesvioMedioConsumoPercentual")[0].stValor : 2.5
    },
    titleCalendar() {
      const {start, end} = this
      if (!start || !end) {
        return ''
      }
      const startMonth = this.monthFormatter(start)
      const endMonth = this.monthFormatter(end)
      var finalMonth = endMonth.charAt(0).toUpperCase() + endMonth.slice(1).toLowerCase()
      const suffixMonth = startMonth === finalMonth ? '' : finalMonth
      
      const startYear = start.year
      const endYear = end.year
      const suffixYear = startYear === endYear ? '' : endYear
      
      const startDay = start.day + ' de '
      const endDay = end.day + ' de '
      
      var atualMonth = startMonth.charAt(0).toUpperCase() + startMonth.slice(1).toLowerCase()
      
      switch (this.type) {
        case 'month':
          return `${atualMonth} ${startYear}`
        case 'week':
        case '4day':
          return `De ${startDay} ${atualMonth} ${startYear} até ${endDay} ${suffixMonth} ${suffixYear}`
        case 'day':
          return `${startDay} ${atualMonth} ${startYear}`
      }
      return ''
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long',
      })
    },
    estabelecimentos() {
      return this.$store.state.estabelecimentos
    },
    urlAPIAmbiencia() {
      return this.$store.state.urlAPIAmbiencia
    },
    podeGerarBoletimSanitario() {
      return this.idUltimoBoletim ||
          this.pesquisaNovoBoletim

    },
  },
  methods: {
    dateIsoToLocal,
    dateLocalToIso,
    dateTimeIsoToLocal,
    daysBetweenDates,
    uepTypeExpand,
    goToAmbiencia(item) {
      this.$router.push({name: 'loteProducaoAmbiencia', params: {ambienceDataType: item}})
    },
    getColorCO2(name) {
      if (name == 'Máxima') {
        return '#10303D'
      } else {
        return '#ff5429'
      }
    },
    getColorTemperatura(name) {
      if (name == 'Esquerda') {
        return '#2196F3'
      } else if (name == 'Direita') {
        return '#4CAF50'
      } else if (name == 'Máxima') {
        return '#10303D'
      } else if (name == 'Externa') {
        return '#9575CD'
      } else {
        return '#ff5429'
      }
    },
    visualizarTodasInfos() {
      this.$router.push({name: 'loteProducaoInfos', params: {id: this.loteProducao.idLoteProducao}})
    },
    editRegistro() {
      this.$router.push({
        name: "loteProducaoForm",
        params: {id: this.loteProducao.idLoteProducao}
      })
    },
    reload() {
      this.exibeGraficoMortalidadeCauses = false
      this.exibeGraficoMotivoMortalidade = false
      this.exibeGraficosConsumoRacao = false
      this.exibePesoDetalhe = false
      this.loadLoteProducao(this.$route.params.id)
    },
    editarRegistroCalendario(item) {
      this.$router.push({
        name: item.tipo,
        params: {idLote: this.loteProducao.idLoteProducao, id: item.idItem}
      })
    },
    novoRegistroDetalhesLote(item) {
      this.$router.push({
        name: item,
        params: {idLote: this.loteProducao.idLoteProducao}
      })
    },
    viewDay({date}) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = this.today
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    showEvent({nativeEvent, event}) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => this.selectedOpen = true, 10)
      }
      
      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }
      
      nativeEvent.stopPropagation()
    },
    updateRange({start, end}) {
      this.start = start
      this.end = end
    },
    selectPesoFinalSelected() {
      this.reload()
    },
    closeDialogInformarPesoFinal() {
      this.nrPesoFinal = ''
      this.dialogInformarPesoFinal = false
    },
    openDialogInformarPesoFinal() {
      this.dialogInformarPesoFinal = true
    },
    selectRationBalanceSelected() {
      this.atualRationBalance = {}
      this.reload()
    },
    closeDialogRationBalance() {
      this.atualRationBalance = {}
      this.dialogRationBalance = false
    },
    openDialogRationBalance() {
      if (this.loteProducao.entradaAnimais.length > 0 && this.loteProducao.qtAlojados > 0) {
        this.dialogRationBalance = true
      } else {
        this.$store.commit('setSnack', {
          type: 'error',
          msg: 'Para informar um saldo de ração é necessário ter animais alojados!'
        })
      }
    },
    editRationBalance(item) {
      this.dialogRationBalance = true
      this.atualRationBalance = item
    },
    loadDadosCalendario() {
      var context = this
      context.valoresCalendario = []
      if (context.flEntradaRacao) {
        context.ration.forEach(function (item) {
          var itemEntradaRacao = {
            idItem: item.idEntradaRacao,
            name: item.racao.nmRacao,
            details: `<table style="width: 475px; overflow-wrap: break-word">
                        <tr><td><strong>Total de ração: </strong>${ item.qtRacao } kg</td></tr>
                        <tr><td><strong>Nota Fiscal: </strong>${ item.nrNotaFiscal }</td></tr>
                        <tr><td><strong>Data: </strong>${ dateIsoToLocal(item.dtEntrada) }</td></tr></table> `,
            start: item.dtInicioConsumo,
            end: item.dtFimConsumo,
            color: 'success',
            tipo: 'loteEntradaRacao',
          }
          context.valoresCalendario.push(itemEntradaRacao)
        })
      }
      
      if (context.flBaixas) {
        context.deaths.forEach(function (i) {
          var dsSexo = '' 
          var motivo = ''
          var txtBaixa = ''
          if (i.sgSexo != null) {
            dsSexo = context.listaGeneros.find(x => x.sgGenero == i.sgSexo).dsGenero
            motivo = i.motivoBaixa != null ? i.motivoBaixa.nmMotivoBaixa : 'Não Informado'
            txtBaixa = i.qtBaixa == 1 ? ' ' + dsSexo : ' ' + dsSexo + 's'
          }
          else {
            motivo = i.motivoBaixa != null ? i.motivoBaixa.nmMotivoBaixa : 'Não Informado'
            txtBaixa = i.qtBaixa == 1 ? ' animail' : ' animais'
          }
          var peso = i.nrPeso != null ? i.nrPeso + ' kg' : '--'
          var itemBaixa = {
            idItem: i.idBaixa,
            name: motivo + ' - ' + i.qtBaixa + txtBaixa,
            details: `<table style="width: 475px; overflow-wrap: break-word">
                        <tr><td><strong>Motivo: </strong>${ motivo }</td></tr>
                        <tr><td><strong>Total: </strong>${ i.qtBaixa } - ${ txtBaixa }</td></tr>
                        <tr><td colspan="2"><strong>Peso médio: </strong>${ peso }</td></tr></table> `,
            start: i.dtBaixa,
            end: i.dtBaixa,
            color: 'error',
            tipo: 'loteBaixa',
          }
          context.valoresCalendario.push(itemBaixa)
        })
      }
      
      if (context.flAdmMedicamento) {
        context.medicines.forEach(function (med) {
          if (med.csTipoAdm != 'RC') {
            var obs = med.dsObservacao != null ? med.dsObservacao : ''
            var totalAnimais = med.qtAnimaisMedicados
            if (totalAnimais == null) {
              totalAnimais = med.csTipoAdm == 'AG' ? 'Todos' : 'Não Informado'
            }
            let strSinaisClinicos = med.sinaisClinicos ?
                med.sinaisClinicos.map(sClinico => sClinico.nmSinalClinico).join(', ') : '';

            var itemAdmFarmaco = {
              idItem: med.idAdmFarmaco,
              name: med.farmaco.nmNome,
              details: `<table style="width: 575px; overflow-wrap: break-word"><tr>
                        <tr><td colspan="2"><strong>Total de animais: </strong>${ totalAnimais }</td></tr>
                        <tr><td><strong>Início tratamento: </strong>${ dateIsoToLocal(med.dtInicioTratamento) }</td>
                        <td><strong>Fim tratamento: </strong>${ dateIsoToLocal(med.dtFimTratamento) }</td></tr>
                        <tr><td colspan="2"><strong>Sinais Clínicos: </strong>${ strSinaisClinicos }</td></tr>
                        <tr><td colspan="2"><strong>Observações: </strong>${ obs }</td></tr></table> `,
              start: med.dtInicioTratamento,
              end: med.dtFimTratamento,
              color: '#ff9629',
              tipo: 'loteAdmFarmacos',
            }
            context.valoresCalendario.push(itemAdmFarmaco)
          }
        })
      }
      
      if (context.flEntrdadaAnimais) {
        context.inputs.forEach(function (i) {
          var textAnimais = i.qtAnimais > 1 ? ' animais' : ' animal'
          var itemEntradaAnimais = {
            idItem: i.idEntradaAnimais,
            name: 'Alojamento - ' + i.qtAnimais + textAnimais,
            details: `<table style="width: 475px; overflow-wrap: break-word">
                        <tr><td><strong>Origem: </strong>${ i.nmOrigem }</td></tr>
                        <tr><td><strong>Data GTA: </strong>${ dateIsoToLocal(i.dtGta) }</td>
                          <td><strong>GTA: </strong>${ i.nrGta } - ${ i.dsSerieGta }</td></tr>
                        <tr><td><strong>Machos: </strong>${ i.qtMachos }</td>
                          <td><strong>Fêmeas: </strong>${ i.qtFemeas }</td>
                          <td><strong>Quantidade total: </strong>${ i.qtMachos + i.qtFemeas }</td></tr></table> `,
            start: i.dtEntrada,
            end: i.dtEntrada,
            color: 'info',
            tipo: 'loteEntradaAnimais',
          }
          context.valoresCalendario.push(itemEntradaAnimais)
        })
      }
      
      if (context.flSaidaAnimais) {
        context.outputs.forEach(function (i) {
          var dataAbateFormatada = i.dtAbate != null ? dateIsoToLocal(i.dtAbate) : ''
          var textAnimais = i.qtAnimais > 1 ? ' animais' : ' animal'
          var qtMachos = i.qtMachos != null ? i.qtMachos : '--'
          var qtFemeas = i.qtFemeas != null ? i.qtFemeas : '--'
          var itemSaidaAnimais = {
            idItem: i.idSaidaAnimais,
            name: 'Saída de Animais - ' + i.qtAnimais + textAnimais,
            details: `<table style="width: 475px; overflow-wrap: break-word">
                        <tr><td><strong>Data GTA: </strong>${ dateIsoToLocal(i.dtGta) }</td>
                        <td><strong>GTA: </strong>${ i.nrGta } - ${ i.dsSerieGta }</td></tr>
                        <tr><td colspan="2"><strong>Data de Abate: </strong>${ dataAbateFormatada }</td></tr>
                        <tr><td><strong>Machos: </strong>${ qtMachos }</td>
                          <td><strong>Fêmeas: </strong>${ qtFemeas }</td>
                          <td><strong>Quantidade total: </strong>${ i.qtAnimais }</td></tr></table> `,
            start: i.dtSaida,
            end: i.dtSaida,
            color: '#b436f4',
            tipo: 'loteSaidaAnimais',
          }
          context.valoresCalendario.push(itemSaidaAnimais)
        })
      }
      if (context.flAmbiencia && context.exibeDadosAmbiencia) {
        // let query = {}
        // query.nrCodigoOficial = context.loteProducao.jsonEstabelecimento.nrCodigoOficial
        // query.nrUnidadeExploracao = parseInt(context.loteProducao.jsonUnidadeExploracao.nrUnidadeExploracao)
        // query.nrPavilhao = context.loteProducao.nrPavilhao
        // var dtInicio = new Date()
        // var dtFim = null
        // if (context.loteProducao.dtFechamentoLote != null) {
        //   dtInicio = new Date(context.dateLocalToIso(context.loteProducao.dtFechamentoLote) + 'T12:00:00Z')
        //   dtFim = new Date(context.dateLocalToIso(context.loteProducao.dtFechamentoLote) + 'T12:00:00Z')
        // }
        // dtInicio.setDate(dtInicio.getDate() - context.loteProducao.nrDiasAlojado)
        // query.dtInicio = dtInicio.toISOString()
        // if (dtFim != null) {
        //   query.dtFim = dtFim.toISOString()
        // }
        
        // List Ambience Alerts
        let query = {}
        const dtStart = moment(moment.now()).add(-this.loteProducao.nrDiasAlojado, "days").toISOString(false)
        query["str_alert_return_data"] = this.loteProducao.idLoteProducao
        query["dt_alert_created_at__gte"] = dtStart
        const ambienceAlertsUrl = new URL("ambience-alerts", AMBIENCE_URL)
        this.$axios.get(ambienceAlertsUrl.toString(), {params: query})
          .then(response => {
            if (!response.data) return
            if (!response.data.data) return
            
            let ambienceAlerts = response.data.data
            ambienceAlerts = keysToCamel(ambienceAlerts)
            ambienceAlerts.forEach((item) => {
              const alertDate = moment(item["dtAlertCreatedAt"]).format("YYYY-MM-DD H:mm")
              this.valoresCalendario.push({
                idItem: item["idAmbienceAlert"],
                name: this.getAlertTitle(item["strAlertName"]),
                details: this.getAlertDescription(item["strAlertName"]),
                start: alertDate,
                end: alertDate,
                color: '#FF5722',
                tipo: 'EV',
              })
            })
          })
          .catch((error) => {
            this.$store.commit('setSnack', {type: 'error', msg: error})
          })
      }
    },
    getAlertTitle(alertName) {
      let title = ""
      if (includes([
        ...ALERT_TEMP_LOWER_MAP_LIST,
        ...ALERT_TEMP_HIGHER_MAP_LIST,
      ], alertName)) {
        title = "Alerta de Temperatura"
      } else if (alertName in [...ALERT_ITU_LOWER_MAP_LIST, ...ALERT_ITU_HIGHER_MAP_LIST]) {
        title = "Alerta de ITU"
      } else if (includes([
        ...ALERT_CO2_1500_PPM_MAP_LIST,
        ...ALERT_CO2_3000_PPM_MAP_LIST
      ], alertName)) {
        title = "Alerta de Concentração de Gás"
      } else if (includes(ALERT_WATER_TEMP_HIGHER_MAP_LIST, alertName)) {
        title = "Alerta de Temperatura da Água"
      }
      
      return title
    },
    getAlertDescription(alertName) {
      let description = ""
      if (includes(ALERT_TEMP_LOWER_MAP_LIST, alertName)) {
        description = "Temperatura muito BAIXA!"
      } else if (includes(ALERT_TEMP_HIGHER_MAP_LIST, alertName)) {
        description = "Temperatura muito ALTA!"
      } else if (includes(ALERT_CO2_1500_PPM_MAP_LIST, alertName)) {
        description = "Valores de gás carbônico acima de 1.500ppm. Aumente a renovação do ar."
      } else if (includes(ALERT_CO2_3000_PPM_MAP_LIST, alertName)) {
        description = "Valores de gás carbônico acima de 3.000 ppm. Nível crítico! Realize a renovação do ar."
      } else if (includes(ALERT_WATER_TEMP_HIGHER_MAP_LIST, alertName)) {
        description = "Temperatura da água muito alta!"
      } else if (includes([
        ...ALERT_ITU_LOWER_MAP_LIST,
        ...ALERT_ITU_HIGHER_MAP_LIST
      ], alertName)) {
        description = "O conforto térmico dos animais está comprometido."
      }
      return description
    },
    loadMortalityDatas(loteProducao) {
      var context = this
      context.exibeGraficoMortalidadeCauses = false
      context.listaMortalityRation = []
      context.mortalityReasonsGraphValues = []
      if (context.loteProducao.baixa.length == 0) {
        return
      }
      
      //ordena as baixas do lote
      loteProducao.baixa.sort((a, b) => {
        return (
          new Date(b.dtBaixa) - new Date(a.dtBaixa) || b.idBaixa - a.idBaixa
        )
      })
      
      loteProducao.baixa.forEach(b => {
        //monstar item da tabela de mortalidade vs racao para cada baixa
        //busca a ração que era consumida quando ocorreu a baixa e se não encontrar usa ' -- '
        var registroRacao = context.loteProducao.entradaRacao.find(i => i.dtInicioConsumo <= b.dtBaixa && i.dtFimConsumo >= b.dtBaixa)
        var nmRacao = registroRacao != undefined ? registroRacao.racao.nmRacao : " - - "
        var racaoMedicada = registroRacao != undefined ? registroRacao.racao.stMedicada == "S" ? "Sim" : "Não" : " - "
        
        let motivo = b.motivoBaixa != null ? b.motivoBaixa.nmMotivoBaixa : "Não Informado"
        
        var diasAlojados = daysBetweenDates(b.dtBaixa, "YYYY-MM-DD", loteProducao.dtAlojamento, "DD/MM/YYYY")
        var semanaAlojado = diasAlojados / 7
        
        let itemMortality = {
          nmCausa: motivo,
          dtBaixa: context.dateIsoToLocal(b.dtBaixa),
          nrDiasAlojamento: diasAlojados,
          nrSemana: Math.ceil(semanaAlojado),
          nmRacao: nmRacao,
          dsMedicada: racaoMedicada,
          qtAnimaisMortos: b.qtBaixa
        }
        context.listaMortalityRation.push(itemMortality)
        
        //montar tabela de causas e percentuais de mortalidade
        let percent = 0
        if (context.loteProducao.qtBaixas > 0)
          percent = ((b.qtBaixa / context.loteProducao.qtBaixas) * 100).toFixed(2)
        let value = {
          itemName: motivo,
          qtAnimais: b.qtBaixa,
          qtPercent: percent
        }
        if (context.mortalityReasonsGraphValues.length != 0) {
          itemMortality = context.mortalityReasonsGraphValues.find(x => x.itemName == motivo)
          if (itemMortality != undefined) {
            itemMortality.qtAnimais = itemMortality.qtAnimais + b.qtBaixa
            let percent = 0
            if (context.loteProducao.qtBaixas > 0)
              percent = ((itemMortality.qtAnimais / context.loteProducao.qtBaixas) * 100).toFixed(2)
            itemMortality.qtPercent = percent
          } else {
            context.mortalityReasonsGraphValues.push(value)
          }
        } else {
          context.mortalityReasonsGraphValues.push(value)
        }
      })
      
      context.mortalityReasonsGraphValues.sort((a, b) => {
        return b.qtAnimais - a.qtAnimais
      })
      
      if (context.$vuetify.breakpoint.name != 'xs') {
        context.exibeGraficoMortalidadeCauses = true
      }
    },
    loadMortalityGoalData(loteProducao) {
      var context = this
      context.$axios.get("lote-producao/" + loteProducao.idLoteProducao + "/mortalidade-semana/")
        .then(response => {
          var rec = response.data[0].data
          this.maxMortesPercent = Math.max.apply(Math, rec.map((obj) => (obj.mortesPercent)))
          var listCategories = []
          var listReal = []
          var listDesejado = []
          context.tabelaMetaMortalidade = context.tabelasMetaMortalidade.find(i => i.sgTipoUep == context.loteProducao.jsonUnidadeExploracao.csTipoUEP)
          if (rec && rec.length > 0) {
            rec.forEach(e => {
              listCategories.push((e.semana * 7).toFixed(0))
              listReal.push(e.mortesPercent)
              if (context.tabelaMetaMortalidade != undefined && context.tabelaMetaMortalidade.pontos != undefined) {
                var mortalidade = context.tabelaMetaMortalidade.pontos.find(i => i.nrDia == e.semana) != undefined ?
                  context.tabelaMetaMortalidade.pontos.find(i => i.nrDia == e.semana).mortalidade : '--'
                listDesejado.push(mortalidade)
              }
            })
            context.mortalityGoalGraphValues.pontosReal = listReal
            context.mortalityGoalGraphValues.pontosDesejado = listDesejado
            context.mortalityGoalGraphValues.pontosCategorias = listCategories
            if (context.$vuetify.breakpoint.name != 'xs') {
              context.exibeGraficoMotivoMortalidade = true
            }
            
          }
        })
    },
    verificaMarcadorMortalidade(nrSemana) {
      if (this.loteProducao.nrIndiceBaixas == undefined) {
        this.loteProducao.marcadorMortalidade = ""
        return
      }
      this.tabelaMetaMortalidade = this.tabelasMetaMortalidade.find(i => i.sgTipoUep == this.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao)
      if (this.tabelaMetaMortalidade == undefined || this.tabelaMetaMortalidade.pontos.length == 0) {
        this.loteProducao.marcadorMortalidade = ""
        return
      }

      this.metaMortalidadeSemana = this.tabelaMetaMortalidade.pontos.find(t => t.nrDia == nrSemana)

      if (this.metaMortalidadeSemana == undefined)
        // necessário ordenar para pegar o último
        this.tabelaMetaMortalidade.pontos.sort((a, b) => a.nrDia - b.nrDia);
        this.metaMortalidadeSemana = this.tabelaMetaMortalidade.pontos[this.tabelaMetaMortalidade.pontos.length - 1]
      
      this.loteProducao.marcadorMortalidade = Math.abs(this.loteProducao.nrIndiceBaixas) >= this.metaMortalidadeSemana.mortalidade ? "alto" : ""
    },
    loadConsumoReal(loteProducao) {
      var context = this
      context.isLoadingConsumoReal = true
      if (loteProducao.jsonConsumoReal != null) {
        context.listaConsumoRealWeekly.esperado = []
        context.listaConsumoRealWeekly.real = []
        context.listaConsumoRealWeekly.nrDias = []
        context.listaConsumoRealAcumulado.esperado = []
        context.listaConsumoRealAcumulado.real = []
        context.listaConsumoRealAcumulado.nrDias = []
        
        context.listaPesoGrafico.esperado = []
        context.listaPesoGrafico.real = []
        context.listaPesoGrafico.nrDias = []
        
        loteProducao.jsonConsumoReal.forEach((item) => {
          context.listaConsumoRealWeekly.esperado.push(item.consumoEsperadoPorAnimalPorDia)
          context.listaConsumoRealWeekly.real.push(item.consumoPorAnimalPorDia)
          context.listaConsumoRealWeekly.nrDias.push(item.diaDoLote.toString())
          context.listaConsumoRealAcumulado.esperado.push(item.consumoAcumuladoEsperadoPorAnimal)
          context.listaConsumoRealAcumulado.real.push(item.consumoAcumuladoPorAnimal)
          context.listaConsumoRealAcumulado.nrDias.push(item.diaDoLote.toString())
        })
        
        if (loteProducao.jsonPeso != null) {
          var pesoEstimado = ''
          var gpdEstimado = ''
          if (loteProducao.jsonPeso.length > 0) {
            loteProducao.jsonPeso.forEach(function (peso) {
              if (peso.diaAlojamento != context.loteProducao.nrDiasAlojado) {
                context.listaPesoGrafico.esperado.push(peso.pesoTotalEsperado)
                context.listaPesoGrafico.real.push(peso.pesoTotal)
                context.listaPesoGrafico.nrDias.push(peso.diaAlojamento)
              }
              peso.consumo = parseFloat(peso.consumo)
            })
            
            context.exibePesoDetalhe = true
            
            if (!loteProducao.blLoteFechado) {
              if (loteProducao.jsonPeso[loteProducao.jsonPeso.length - 1].diaAlojamento < loteProducao.nrDiasAlojado) {
                var pesoProjetadoHoje = {
                  diaAlojamento: loteProducao.nrDiasAlojado,
                  gpd: this.qtGpdEstimado,
                  pesoTotal: loteProducao.nrPesoEstimado.toFixed(3)
                }
                loteProducao.jsonPeso.push(pesoProjetadoHoje)
                context.exibeTextPesoProjetado = true
              }
            }
          }
        }
        context.exibeGraficosConsumoRacao = true
      }
    },
    loadEndRationDate(id) {
      var context = this
      this.dtDifereceDateFimRacao = '--'
      this.dtFimRacao = '--'
      if (!context.loteProducao.blLoteFechado && context.loteProducao.dtFimConsumoRacao != null) {
        this.dtFimRacao = dateIsoToLocal(context.loteProducao.dtFimConsumoRacao)
        this.dtDifereceDateFimRacao = daysBetweenDates(context.loteProducao.dtFimConsumoRacao, "YYYY-MM-DD", new Date().toLocaleDateString("pt-br"), "DD/MM/YYYY")
      }
    },
    loadUEP(loteProducao) {
      if (loteProducao.jsonUnidadeExploracao) {
        this.uep = loteProducao.jsonUnidadeExploracao
        this.uep.csTipoUEP = this.uep.csTipoUnidadeExploracao
        this.uep.csTipoUnidadeExploracao = uepTypeExpand(this.uep.csTipoUnidadeExploracao)
      }
    },
    loadProdutor(loteProducao) {
      if (loteProducao.jsonProdutor) {
        var pavilhao = loteProducao.nrPavilhao != null ? ' - Pavilhão ' + loteProducao.nrPavilhao : ''
        let displayName = loteProducao.jsonProdutor.nmProdutor + pavilhao
        this.produtor = {...loteProducao.jsonProdutor, displayName}
        if (loteProducao.jsonProdutor != undefined) {
          this.displayName = displayName
        }
      }
    },
    loadEstabelecimento(loteProducao) {
      if (loteProducao.jsonEstabelecimento) {
        let displayName = loteProducao.jsonEstabelecimento.nrCodigoOficial + " - " + loteProducao.jsonEstabelecimento.nmEstabelecimento
        this.estabelecimento = {...loteProducao.jsonEstabelecimento, displayName}
        this.displayName = displayName
      }
    },
    loadBoletimSanitario(idLoteProducao) {
      let query = new URLSearchParams()
      let cfCdStatusBoletimSanitario = { "field": "cdStatusBoletimSanitario", "op": "<", "value": 5 }
      let cfDhFimRegistro = { "field": "dhFimRegistro", "op": "is", "value": null }

      query.append("cdLoteProducao", idLoteProducao)
      query.append("cf", JSON.stringify(cfCdStatusBoletimSanitario))
      query.append("cf", JSON.stringify(cfDhFimRegistro))

      this.$axios.get('boletim-sanitario/', { params: query })
      .then(res => {
        if (!res.data) return
        if (!res.data[0].data) return

        this.idUltimoBoletim = _.maxBy(res.data[0].data, boletim => boletim.idBoletimSanitario)['idBoletimSanitario']
      })
      .catch(error => {
        this.$store.commit("setSnack", {type: "error", msg: error})
      })
    },
    loadLotePodeGerarBoletim(nrLoteControle) {
      this.$axios.get('boletim-sanitario/lote-producao-search/', {params: {"nrLoteControle": nrLoteControle}})
          .then((response) => {
            if (!response.data) return
            if (!response.data[0].data) {
              this.pesquisaNovoBoletim = false
              return
            }

            this.pesquisaNovoBoletim = true
          })
          .catch(error => {
            this.$store.commit('setSnack', {type: 'error', msg: error})
          })
    },
    loadLoteProducao(id) {
      this.$axios.get("lote-producao/" + id)
        .then(response => {
          var context = this
          context.loteProducao = response.data[0].data
          this.loadLotePodeGerarBoletim(context.loteProducao.nrLoteControle)
          
          context.loteProducao.dtCriacaoLote = dateIsoToLocal(context.loteProducao.dtCriacaoLote)
          context.loteProducao.dtFechamentoLote = dateIsoToLocal(context.loteProducao.dtFechamentoLote)
          context.loteProducao.dtAlojamento = dateIsoToLocal(context.loteProducao.dtAlojamento)
          context.loteProducao.dsTipoSexo = context.tiposGenero.find(i => i.sgSexo === context.loteProducao.sgSexo).dsSexo
          context.loteProducao.nmTabela = context.loteProducao.tabelaConsumoRacao != null ? context.loteProducao.tabelaConsumoRacao.nmTabela : ""
          context.loteProducao.nmExtensionista = context.loteProducao.responsavelTecnico != null ? context.loteProducao.responsavelTecnico.nmPessoa : ""
          
          if (context.loteProducao.entradaRacao != null) {
            context.ration = [...context.loteProducao.entradaRacao].sort((a, b) => {
              return new Date(b.dtInicioConsumo) - new Date(a.dtInicioConsumo)
            })
            context.totalRation = 0
            context.ration.forEach(function (item) {
              context.totalRation = context.totalRation + item.qtRacao
            })
          }
          
          if (context.loteProducao.baixa != null) {
            context.deaths = [...context.loteProducao.baixa].sort((a, b) => {
              return new Date(b.dtBaixa) - new Date(a.dtBaixa)
            })
          }
          
          context.medicines = []
          if (context.loteProducao.admFarmaco != null) {
            [...context.loteProducao.admFarmaco].forEach(function (med) {
              if (med.farmaco != null) {
                context.medicines.push(med)
              }
            })
            context.medicines = context.medicines.sort((a, b) => {
              return new Date(b.dtInicioTratamento) - new Date(a.dtInicioTratamento)
            })
          }
          
          if (context.loteProducao.entradaAnimais != null) {
            context.inputs = [...context.loteProducao.entradaAnimais].map(entry => {
              var estabelecimento = context.estabelecimentos.find(x => x.idEstabelecimento == entry.cdEstabelecimentoOrigem)
              let nmOrigem = estabelecimento ? estabelecimento.nmEstabelecimento : 'Estabelecimento Deletado'
              return {...entry, nmOrigem}
            })
            
            context.inputs = context.inputs.sort((a, b) => {
              return new Date(b.dtEntrada) - new Date(a.dtEntrada)
            })
          }
          
          if (context.loteProducao.saidaAnimais != null) {
            context.outputs = [...context.loteProducao.saidaAnimais]
          }
          
          if (!context.loteProducao.blLoteFechado) {
            context.loteProducao.nrDiasAlojado = context.loteProducao.dtAlojamento != null ?
              daysBetweenDates(new Date().toLocaleDateString("pt-br"), "DD/MM/YYYY", context.loteProducao.dtAlojamento, "DD/MM/YYYY") : 0
          } else {
            context.focus = dateLocalToIso(context.loteProducao.dtFechamentoLote)
            context.loteProducao.nrDiasAlojado = context.loteProducao.dtAlojamento != null ?
              daysBetweenDates(context.loteProducao.dtFechamentoLote, "DD/MM/YYYY", context.loteProducao.dtAlojamento, "DD/MM/YYYY") : 0
          }
          
          //Dados semana, peso, gpd e marcdor mortalidade
          if (context.loteProducao.nrDiasAlojado > 0) {
            var nrSemana = context.loteProducao.nrDiasAlojado / 7
            nrSemana = Math.ceil(nrSemana) //+ 1;
            
            context.verificaMarcadorMortalidade(nrSemana)
            
            nrSemana = context.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao == "TR" ? nrSemana + 9 : nrSemana + 4
            context.nrSemanaTabela = nrSemana
          }
          
          context.loadDadosCalendario()
          context.loadEstabelecimento(context.loteProducao)
          context.loadUEP(context.loteProducao)
          context.loadProdutor(context.loteProducao)
          context.loadEndRationDate(id)
          context.loadConsumoReal(context.loteProducao)
          context.loadMortalityGoalData(context.loteProducao)
          context.loadMortalityDatas(context.loteProducao)
          
          context.$store.commit('mtChangeLoteProducaoAtual', context.loteProducao)

          if (context.$vuetify.breakpoint.name != 'xs') {
            context.exibeGraficoMortalidadeCauses = true
          }
        })
        .catch((error) => {
          this.$store.commit('setSnack', {type: 'error', msg: error})
          this.$router.push({path: '/lotes'})
        })
    },
    initViewFromRoute(route) {
      let id = route.params.id
      this.$store.dispatch('actLoadEstabelecimentos')
      if (id) {
        this.loadLoteProducao(id)
        this.loadBoletimSanitario(id)
      } else {
        //load empty
      }
    },
    novoRegistro() {
      this.$router.push({path: '/loteProducaoForm'})
    },
    goSearch() {
      this.$router.push({path: '/loteProducaoSearch'})
    },
    voltar() {
      this.$router.go(-1)
    },
    onGenerateFalClick() {
      const idLoteProducao = this.$route.params.id
      this.$axios.get(`lote-producao/${idLoteProducao}/fal-digital/`, {
        responseType: "blob"
      }).then((res) => {
          let blob = new Blob([res.data], {type: 'application/octet-stream'})
          let a = document.createElement('a');
          a.href = URL.createObjectURL(blob)
          a.download = `fal_digital-${this.loteProducao.jsonProdutor["nmProdutor"]}.pdf`;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
    },
    toBoletimSanitario() {
      if (!this.podeGerarBoletimSanitario) return
      if (this.idUltimoBoletim && this.idUltimoBoletim > 0)
        this.$router.push('/boletimSanitario/'+ this.idUltimoBoletim)
      else this.$router.push('/boletimSanitario/?lp='+ this.$route.params.id)
    },
  },
  watch: {
    '$route'(to) {
      this.initViewFromRoute(to)
    },
  },
  mounted() {
    this.initViewFromRoute(this.$route)
  },
}
</script>

<style scoped>
.item {
  margin: 1px
}

.marginTitle {
  margin: 15px;
}

.headerCard {
  color: white;
  background: #04222D;
  padding: 10px;
}
</style>